import React, { useContext } from 'react'
import { Box, ImageLoader, Text } from '@usap/uicomponents'
import { SelectedItemsContext } from '../../contexts/SelectedItemsContextProvider'
import styled from 'styled-components'

export default function ReturnStatusWMO({
    returnStatusData,
    setDisplayReturnDetails,
    setReturnDetailsData,
    isDesktop,
}) {
    const selectedItemsContextData = useContext(SelectedItemsContext)
    const {
        orderItems,
        setOrderItems,
    } = selectedItemsContextData

    const {
        message,
        returnRequestId,
        rmaId,
        merchantOrderId,
        creditId,
        email,
        orderId,
        orderItemId,
        imagesData = [],
    } = returnStatusData

    let idNumber = returnRequestId
    let idType = 'Return Request ID'

    if (creditId) {
        idNumber = creditId
        idType = 'Credit ID'
    }

    if (rmaId && rmaId !== 'GP RMA not received.') {
        idNumber = rmaId
        idType = 'RMA ID'
    }

    if (!returnRequestId && !rmaId && !creditId) return null

    const triggerReturnDetailsDisplay = () => {
        const dataReturn = {
            returnRequestId,
            merchantOrderId,
            orderId,
            orderItemId,
            rmaId,
            creditId,
            email,
        }
        if (orderItems && orderItems.length) setOrderItems([])
        setDisplayReturnDetails(true)
        setReturnDetailsData(dataReturn)
    }

    const displayImages = () => Array.isArray(imagesData) && imagesData.map(data => (
        <Box
            key={data.sku_title}
            width="70px"
            pad="xsmall"
            background={{ color: 'white' }}
            round="small"
        >
            <ImageLoader
                fit="contain"
                alt={data.sku_title}
                src={data.ImageURL}
                width="100%"
                height="100%"
                cloudinaryParams="w_100,h_80"
            />
        </Box>
    ))

    const ImageContainer = styled.div``;

    return (
        <Box
            style={{
                background: '#F4F4F4',
                padding: '12px',
                width: isDesktop ? '500px' : '100%',
                display: 'flex',
                alignItems: 'flex-start',
                marginTop: '16px',
                borderRadius: '4px'
            }}
        >
            <Text
                color="dark-2"
                size="16px"
                weight="600"
                style={{ lineHeight: '26.4px' }}
            >
                {message}
            </Text>
            <Text color='dark-2' size="14px" weight={400} style={{ lineHeight: '23.1px' }}>
                {idType}
                :
                &nbsp;
                <Text color='dark-2' size="14px" weight={600} >{idNumber}</Text>
            </Text>
            <ImageContainer
                gap="small"
                direction="row"
                margin={{ vertical: '12pt' }}
            >
                {displayImages()}
            </ImageContainer>
            <Box onClick={triggerReturnDetailsDisplay} margin={{ top: '8px' }}>
                <Text
                    color="blueLink"
                    size="small"
                    alignSelf="center"
                    style={{ textDecoration: 'underline' }}
                >
                    See Return Details
                </Text>
            </Box>
        </Box>
    )
}
